
/**
 * @domName 传入一个选择器可以选择的类名，id名，或者属性选择器，必须保持页面唯一性，默认body
 */
import { UpOutlined } from '@ant-design/icons-vue';
export default {
  name: 'BackTop',
  props: {
    domName: {
      type: String,
      default: 'body',
    },
  },
  components: {
    UpOutlined,
  },

  setup(props) {
    const domName = props?.domName || '';
    const getScrollDom = () => {
      if (!domName) return;
      return document.querySelector(domName);
    };
    return {
      getScrollDom,
    };
  },
};
